import { useQuery } from '@tanstack/react-query';
import { IUnreadCounts } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const getHelpDeskUnreadCount = async () => {
  const res = await apiManager.get<IUnreadCounts>(
    "/admin/complaints-unread-count"
  );
  return res;
};

export const useGetHelpDeskUnreadCount = () =>
  useQuery({
    queryKey: ["help_desk_unread_count"],
    queryFn: async () => {
      const res = await apiClient.get("/admin/complaints-unread-count");
      return res.data;
    },
  });